import { render, staticRenderFns } from "./AutomaticPrices.vue?vue&type=template&id=45c63576&"
import script from "./AutomaticPrices.vue?vue&type=script&lang=js&"
export * from "./AutomaticPrices.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticPrices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QMenu,QList,QItem,QItemSection,QItemLabel,QToggle,QSelect,QInput,ClosePopup,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtn,QMenu,QList,QItem,QItemSection,QItemLabel,QToggle,QSelect,QInput})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup,Ripple})
